import React from 'react';
import PropTypes from 'prop-types';

import { Overlay } from './styles';

const VideoOverlay = ({
  className,
  children,
  thumbnail,
  onClick,
  bgPosition,
}) => {
  return (
    <Overlay
      className={className}
      image={thumbnail}
      onClick={onClick}
      bgPosition={bgPosition}
    >
      {children}
    </Overlay>
  );
};

VideoOverlay.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  thumbnail: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  bgPosition: PropTypes.string,
};

VideoOverlay.defaultProps = {
  className: null,
  children: null,
  bgPosition: 'top center',
};

export default VideoOverlay;
